<template>
  <div class="flex h-screen bg-gray-50 overflow-hidden relative">
    <!-- Mobile overlay -->
    <div 
      v-if="isSidebarOpen" 
      @click="isSidebarOpen = false"
      class="fixed inset-0 bg-black/50 z-40 lg:hidden transition-opacity"
    ></div>

    <AppSidebar 
      :class="[
        'fixed lg:static inset-y-0 left-0 z-50 transform transition-transform duration-300 ease-in-out lg:transform-none lg:translate-x-0',
        isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
      ]" 
    />

    <div class="flex-1 flex flex-col overflow-hidden min-w-0">
      <AppHeader @toggle-sidebar="isSidebarOpen = !isSidebarOpen" />

      <main class="flex-1 overflow-y-auto p-4 lg:p-6">
        <router-view :key="$route.fullPath" />
      </main>
    </div>
  </div>
</template>

<script>
import AppSidebar from "@/components/AppSidebar.vue";
import AppHeader from "@/components/AppHeader.vue";

export default {
  name: "DefaultLayout",
  components: {
    AppSidebar,
    AppHeader,
  },
  data() {
    return {
      isSidebarOpen: false
    };
  },
  watch: {
    $route() {
      // Har gal sahifa o'zgarganda mobil sidebar yopiladi
      this.isSidebarOpen = false;
    }
  }
};
</script>
